import { render, staticRenderFns } from "./typeTwoOrThree.vue?vue&type=template&id=8f10f17e&scoped=true"
import script from "./typeTwoOrThree.vue?vue&type=script&lang=js"
export * from "./typeTwoOrThree.vue?vue&type=script&lang=js"
import style0 from "./typeTwoOrThree.vue?vue&type=style&index=0&id=8f10f17e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f10f17e",
  null
  
)

export default component.exports